import React, { useState } from 'react';
import { Button, NavBar, Icon } from 'antd-mobile';
import { merge, clone, get, remove, pullAt, concat, at } from 'lodash';
import './index.scss';
const Vh5Tags = props => {
	let { tagsData, saveCallback, onClose, placeholder, filterCallback, tagsKey, selectedTags } = props;
	let [newTags, setNewTags] = useState(selectedTags);
	function setDefaultValue(item) {
		return newTags.findIndex(v => {
			return v === item;
		});
	}
	function onTagsItemClick(v, i) {
		let tags = clone(newTags);
		let index = setDefaultValue(v);
		if (index > -1) {
			tags.splice(index, 1);
		} else {
			tags.push(v);
		}
		setNewTags(tags);
	}
	return (
		<div className="vtags-wrap">
			<div className={'vbar-wrap '}>
				<NavBar
					mode="light"
					icon={<Icon type="left" />}
					onLeftClick={() => onClose()}
					rightContent={[
						<span key="0" className="back" onClick={saveCallback.bind(this, newTags)}>
							确定
						</span>
					]}>
					添加标签
				</NavBar>
			</div>
			<div className="default-tags-container">
				<div className="tags-title">默认标签</div>
				<div className="tags-container">
					{tagsData &&
						tagsData.map((item, index) => {
							return (
								<div
									key={'tags-item' + index}
									className={'tags-item ' + (setDefaultValue(item) > -1 ? 'active' : '')}
									onClick={() => {
										onTagsItemClick(item, index);
									}}>
									<i>&#xe65f;</i>
									{item}
								</div>
							);
						})}
				</div>
			</div>
			<div className="selected-tags-container">
				<div className="tags-container">
					{newTags &&
						newTags.map((item, index) => {
							return (
								<div
									key={'tags-item' + index}
									className={'tags-item '}
									onClick={() => {
										let tags = clone(newTags);
										tags.splice(index, 1);
										setNewTags(tags);
									}}>
									<i>&#xe65f;</i>
									{item}
									<i style={{ marginLeft: '5px' }}>&#xe652;</i>
								</div>
							);
						})}
				</div>
				<input
					type="text"
					className="tags-input"
					placeholder="请输入标签内容"
					onKeyDown={event => {
						let e = event || window.event; //||window.arguments.callee.caller.arguments[0];
						if (e && e.keyCode === 13 && event.target.value) {
							let tags = clone(newTags);
							tags.push(event.target.value);
							setNewTags(tags);
							event.target.value = '';
						} else if (e && e.keyCode === 8 && event.target.value === '') {
							let tags = clone(newTags);
							tags.splice(tags.length - 1, 1);
							setNewTags(tags);
						}
					}}
					onBlur={event => {
						if (event.target.value) {
							let tags = clone(newTags);
							tags.push(event.target.value);
							setNewTags(tags);
							event.target.value = '';
						}
					}}
				/>
			</div>
		</div>
	);
};
export { Vh5Tags };
